import {
  ADD_FILE,
  ADD_ITEM,
  CHANGE_DEADLINE_DATE,
  CHANGE_DEADLINE_TIME,
  CHANGE_ITEM_DESCRIPTION,
  CHANGE_ITEM_TITLE,
  CHANGE_PRIORITY,
  CHANGE_PROJECT,
  CHANGE_TITLE,
  CLEAR_ORDER_ID,
  CLOSE_EDIT_ITEM,
  ORDER_INITIALIZATION_RECEIVED,
  REMOVE_FILE,
  REMOVE_ITEM,
  START_ADD_ITEM,
  START_EDIT_ITEM,
  START_ORDER,
  SUBMIT_ORDER,
  SUBMIT_ORDER_FAILED,
  SUBMIT_ORDER_SUCCEEDED,
  VALIDATE_ORDER,
  SAVE_ITEM
} from '../actions/axisOrder';

const initialState = {
  currentItem: {},
  deadline: {},
  errorMessage: '',
  files: [],
  hasChanges: false,
  hiddenMessage: '',
  isValidating: false,
  items: [],
  orderId: -1,
  projects: [],
  selectedPriority: 3,
  selectedProject: '',
  successMessage: '',
  title: ''
};

const ACTION_HANDLERS = {
  [ADD_FILE]: (state, action) => ({
    ...state,
    files: [...state.files, ...action.payload.files]
  }),
  [ADD_ITEM]: (state) => {
    const updatedState = {
      ...state,
      currentItem: {},
      errorMessage: '',
      items: [
        ...state.items,
        Object.assign({}, state.currentItem)
      ],
      successMessage: ''
    };
    const hiddenMessage = getHiddenMessage(updatedState);
    return {
      ...updatedState,
      hasChanges: getHasChanges(updatedState),
      hiddenMessage,
      isValidating: state.isValidating && hiddenMessage !== ''
    };
  },
  [CHANGE_DEADLINE_DATE]: (state, action) => ({
    ...state,
    deadline: {
      ...state.deadline,
      date: action.payload.date
    },
    successMessage: ''
  }),
  [CHANGE_DEADLINE_TIME]: (state, action) => ({
    ...state,
    deadline: {
      ...state.deadline,
      time: action.payload.time
    },
    successMessage: ''
  }),
  [CHANGE_ITEM_DESCRIPTION]: (state, action) => {
    const updatedState = {
      ...state,
      currentItem: {
        ...state.currentItem,
        description: action.payload.description
      },
      successMessage: ''
    };
    const hiddenMessage = getHiddenMessage(updatedState);
    return {
      ...updatedState,
      hasChanges: getHasChanges(updatedState),
      hiddenMessage,
      isValidating: state.isValidating && hiddenMessage !== ''
    };
  },
  [CHANGE_ITEM_TITLE]: (state, action) => {
    const updatedState = {
      ...state,
      currentItem: {
        ...state.currentItem,
        title: action.payload.title
      },
      successMessage: ''
    };
    const hiddenMessage = getHiddenMessage(updatedState);
    return {
      ...updatedState,
      hasChanges: getHasChanges(updatedState),
      hiddenMessage,
      isValidating: state.isValidating && hiddenMessage !== ''
    };
  },
  [CHANGE_PRIORITY]: (state, action) => ({
    ...state,
    selectedPriority: Number(action.payload.priorityId),
    successMessage: ''
  }),
  [CHANGE_PROJECT]: (state, action) => {
    const selectedProject = state.projects.find(p => p.id === action.payload.projectId);
    return {
      ...state,
      deadline: selectedProject.deadline,
      selectedProject: action.payload.projectId,
      successMessage: ''
    };
  },
  [CHANGE_TITLE]: (state, action) => {
    const updatedState = {
      ...state,
      title: action.payload.title,
      successMessage: ''
    };
    const hiddenMessage = getHiddenMessage(updatedState);
    return {
      ...updatedState,
      hasChanges: getHasChanges(updatedState),
      hiddenMessage,
      isValidating: state.isValidating && hiddenMessage !== ''
    };
  },
  [CLEAR_ORDER_ID]: (state) => ({
    ...state,
    orderId: -1,
    successMessage: ''
  }),
  [CLOSE_EDIT_ITEM]: (state) => {
    const updatedState = {
      ...state,
      currentItem: {},
      errorMessage: '',
      successMessage: ''
    };
    const hiddenMessage = getHiddenMessage(updatedState);
    return {
      ...updatedState,
      hasChanges: getHasChanges(updatedState),
      hiddenMessage,
      isValidating: state.isValidating && hiddenMessage !== ''
    };
  },
  [ORDER_INITIALIZATION_RECEIVED]: (state, action) => {
    const selectedProject = action.payload.projects.find(p => p.id === state.selectedProject);
    const validProjects = action.payload.projects.filter(
      p => p.assettypes.some(t => t.toString() === state.currentItem.assetTypeId.toString()));
    return {
      ...state,
      deadline: selectedProject.deadline,
      projects: validProjects
    };
  },
  [REMOVE_FILE]: (state, action) => {
    if (state.files.length > action.payload.index) {
      const updatedFiles = [...state.files];
      updatedFiles.splice(action.payload.index, 1);
      return {
        ...state,
        files: updatedFiles
      };
    }

    return state;
  },
  [REMOVE_ITEM]: (state, action) => {
    if (state.items.length > action.payload.index) {
      const updatedItems = [...state.items];
      const deletedItem = state.items[action.payload.index];
      updatedItems.splice(action.payload.index, 1);

      const updatedState = {
        ...state,
        currentItem: state.currentItem.replaceableId === deletedItem.replaceableId ?
          {} : state.currentItem,
        errorMessage: '',
        items: updatedItems
      };
      return {
        ...updatedState,
        hasChanges: getHasChanges(updatedState),
        hiddenMessage: getHiddenMessage(updatedState)
      };
    }

    return state;
  },
  [SAVE_ITEM]: (state) => {
    const items = state.items.map(i => {
      if (i.replaceableId === state.currentItem.replaceableId) {
        return {
          ...i,
          description: state.currentItem.description,
          title: state.currentItem.title
        };
      }

      return i;
    });
    return {
      ...state,
      currentItem: {},
      errorMessage: '',
      items,
      successMessage: ''
    };
  },
  [START_ADD_ITEM]: (state, action) => {
    const {
      axisOrderAssetType,
      axisOrderMediaFormat,
      displayName,
      replaceableId,
      replaceableType } = action.payload;
    if (!axisOrderAssetType || !axisOrderMediaFormat) {
      return {
        ...state,
        errorMessage: 'Media Format not defined for this item and cannot be added to an Order.'
      };
    }
    if (state.items.some(i => i.replaceableId === replaceableId)) {
      return {
        ...state,
        errorMessage: 'The replaceable has already been added to the order.'
      };
    }
    if (state.currentItem.replaceableId === replaceableId) {
      return state;
    }

    const projectAssetTypes = state.projects.find(p => p.id === state.selectedProject).assettypes;
    if (!projectAssetTypes.some(a => a.toString() === axisOrderAssetType.toString())) {
      return {
        ...state,
        errorMessage: 'Asset Type defined for this item is not allowed for the selected project.'
      };
    }
    const updatedState = {
      ...state,
      currentItem: {
        assetTypeId: axisOrderAssetType,
        defaultTitle: displayName,
        mediaFormatId: axisOrderMediaFormat,
        replaceableId,
        replaceableType,
        title: displayName,
        description: ''
      },
      errorMessage: ''
    };
    return {
      ...updatedState,
      hasChanges: getHasChanges(updatedState),
      hiddenMessage: getHiddenMessage(updatedState),
      isValidating: false
    };
  },
  [START_EDIT_ITEM]: (state, action) => {
    const currentItem = state.items.find(i => i.replaceableId === action.payload.replaceableId);
    return {
      ...state,
      currentItem,
      errorMessage: ''
    };
  },
  [START_ORDER]: (state, action) => {
    const { id, properties, type } = action.payload.replaceable;
    const { axisOrderAssetType, axisOrderMediaFormat, axisOrderProject, displayName } = properties;
    return {
      ...initialState,
      currentItem: {
        assetTypeId: axisOrderAssetType,
        defaultTitle: displayName,
        mediaFormatId: axisOrderMediaFormat,
        replaceableId: id,
        replaceableType: type,
        title: displayName,
        description: ''
      },
      hiddenMessage: getHiddenMessage(state),
      selectedProject: axisOrderProject
    };
  },
  [SUBMIT_ORDER]: (state) => ({
    ...state,
    isValidating: false,
    errorMessage: 'Submitting order. This may take a few moments.'
  }),
  [SUBMIT_ORDER_FAILED]: (state) => ({
    ...state,
    errorMessage: 'Order could not be created.',
    successMessage: ''
  }),
  [SUBMIT_ORDER_SUCCEEDED]: (state, action) => {
    const updatedState = {
      ...state,
      currentItem: {},
      errorMessage: '',
      files: [],
      hasChanges: false,
      items: [],
      orderId: action.payload.orderId,
      successMessage: `Order ${action.payload.orderId} submitted`,
      title: ''
    };
    return {
      ...updatedState,
      hiddenMessage: getHiddenMessage(updatedState)
    };
  },
  [VALIDATE_ORDER]: (state) => ({
    ...state,
    isValidating: true
  })
};

const isValidTitle = (state) => state.title.trim().length > 0;

const isValidDeadline = (state) => {
  try {
    const deadline = new Date(`${state.deadline.date} ${state.deadline.time}`);

    return deadline > new Date();
  } catch (error) {
    return false;
  }
};

const isValidEditItem = (state) => state.currentItem.assetTypeId === undefined ||
  (state.currentItem.title.trim().length > 0 && state.currentItem.description.trim().length > 0);

const getHiddenMessage = (state) => {
  if (!isValidTitle(state) || !isValidEditItem(state)) {
    return 'Please enter required fields.';
  }

  if (!isValidDeadline(state)) {
    return 'Please check that the deadline is valid.';
  }

  if (state.currentItem.assetTypeId === undefined &&
    state.items.length === 0) {
    return 'Please add an item.';
  }

  return '';
};

const getHasChanges = (state) => {
  const itemChanged = state.currentItem.assetTypeId !== undefined &&
    (state.currentItem.title !== state.currentItem.defaultTitle ||
      state.currentItem.description !== '');

  return state.title !== '' || state.items.length > 0 || itemChanged;
};

export default function asset(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./app/reducers/axisOrder.js